import { formatDistanceToNow, differenceInDays, parseISO } from "date-fns";

export function convertToReadable(timestamp) {
    // Months mapping for formatting
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    // Parsing the timestamp
    var dateParts = timestamp.split(" ")[0].split("-");
    var timeParts = timestamp.split(" ")[1].split(":");

    var year = parseInt(dateParts[0]);
    var month = months[parseInt(dateParts[1]) - 1];
    var day = parseInt(dateParts[2]);

    var hour = parseInt(timeParts[0]);
    var minute = parseInt(timeParts[1]);

    // Formatting the time
    var period = "AM";
    if (hour >= 12) {
        period = "PM";
        if (hour > 12) {
            hour -= 12;
        }
    }
    if (hour === 0) {
        hour = 12;
    }

    // Creating the formatted string
    var formattedTime = day + " " + month + ", " + year + ", " + hour + ":" + (minute < 10 ? "0" + minute : minute) + " " + period;
    return formattedTime;
}

export function convertISOToReadable(timestamp, monthType = 'long', showTime = true) {
    // Create a Date object from the timestamp
    timestamp = timestamp.includes('T') ? timestamp.replace('T', ' ') : timestamp;
const date = new Date(timestamp);

// Format the date
const formattedDate = date.toLocaleDateString('en-US', {
  year: 'numeric',
  month: monthType,
  day: 'numeric'
});

// Format the time
const formattedTime = date.toLocaleTimeString('en-US', {
  hour: 'numeric',
  minute: '2-digit'
});

const showFormattedTime = (showTime) ? `,${formattedTime}` : '';
// Concatenate the formatted date, time, and period
return `${formattedDate}` + (showFormattedTime);
}

export function validityFormatDate(selectedValidityDate) {
    const date = new Date(selectedValidityDate);
    const formatedValidityDate = date.getFullYear() + '-' +
    String(date.getMonth() + 1).padStart(2, '0') + '-' +
    String(date.getDate()).padStart(2, '0') + ' ' +
    String(date.getHours()).padStart(2, '0') + ':' +
    String(date.getMinutes()).padStart(2, '0') + ':' +
    String(date.getSeconds()).padStart(2, '0');
    return formatedValidityDate;
}

export function formatDaysAgo(dateString) {
    const givenDate = new Date(dateString);
    return formatDistanceToNow(givenDate, { addSuffix: true });
}

export function convertUTCtoLocalTime(inputDate, inputTimezone = false) {
    let date     = typeof inputDate != 'undefined' && inputDate != false ? inputDate : '';
    date         = new Date(date);
    let timeZone = (inputTimezone == false) ? false : inputTimezone;
    const event  = new Date(Date.UTC(
                                    date.getUTCFullYear(),
                                    date.getUTCMonth(),
                                    date.getUTCDate(),
                                    date.getUTCHours(),
                                    date.getUTCMinutes(),
                                    date.getUTCSeconds())
                                );
    var convertedTime = event.toLocaleString('en-US', {timeZone});

    if(typeof timeZone != 'undefined' && timeZone != false ) {
        return new Date(convertedTime);
    } else {
        return date;
    }
}

export function daysDifference(startDateTime, endDateTime) {
    const endDateParam   = endDateTime;
    const startDateParam = startDateTime;
    // Parse ISO strings into Date objects
    const endDate        = parseISO(endDateParam);
    const startDate      = parseISO(startDateParam);
    // Calculate the difference in days
    return differenceInDays(endDate, startDate) ?? 0;

}